import React from 'react'

interface SessionPanelProps {
  sessionId: string
  openedAt: string
  onWithdraw: () => void
  onClose: () => void
  onRefresh: () => void
  refreshing: boolean
}

export const SessionPanel: React.FC<SessionPanelProps> = ({
  sessionId,
  openedAt,
  onWithdraw,
  onClose,
  onRefresh,
  refreshing,
}) => {
  return (
    <div className="bg-white rounded-xl shadow-md p-4 space-y-2">
      <h3 className="text-lg font-semibold">Sesión Actual</h3>
      <p>ID: {sessionId}</p>
      <p>Apertura: {openedAt}</p>
      <div className="flex items-center gap-2">
        <span className="px-2 py-1 text-xs rounded bg-green-100 text-green-700">Caja Abierta</span>
      </div>
      <div className="flex gap-2 mt-2 flex-wrap">
        <button
          onClick={onRefresh}
          disabled={refreshing}
          className="border border-gray-300 rounded px-3 py-1 hover:bg-gray-50 disabled:opacity-50"
        >
          {refreshing ? 'Actualizando...' : 'Actualizar'}
        </button>
        <button
          onClick={onWithdraw}
          className="border border-gray-300 rounded px-3 py-1 hover:bg-gray-50"
        >
          Registrar Retiro
        </button>
        <button
          onClick={onClose}
          className="bg-gradient-to-r from-red-500 to-red-700 text-white rounded px-3 py-1"
        >
          Cerrar Caja
        </button>
      </div>
    </div>
  )
}
